<script setup>
import Multiselect from '@vueform/multiselect';
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: Array,
    default() {
      return [];
    },
  },
  options: {
    type: Array,
    default() {
      return [];
    },
  },
  multipleLabel: {
    type: String,
    default: 'Кол-во:',
  },
  placeholder: {
    type: String,
    default: 'Все',
  },
  noOptionsText: {
    type: String,
    default: 'Список пуст'
  }
});
const emit = defineEmits(['update:value']);

const selectedItems = computed({
  get: () => props.value,
  set: (val) => emit('update:value', val),
});
</script>

<template>
  <Multiselect
    v-model="selectedItems"
    mode="multiple"
    :placeholder="placeholder"
    :options="options"
    :hide-selected="false"
    :close-on-select="false"
    :noOptionsText="noOptionsText"
    :multiple-label="n => `${multipleLabel} ${n.length}`"
  >
    <template #option="{ option, isSelected }">
      <input
        type="checkbox"
        class="checkbox__input"
        :checked="isSelected(option)"
      >
      <span class="checkbox__custom" />
      {{ option.label }}
    </template>
    <template #caret>
      <svg
        width="20"
        height="20"
        class="icon down_icon mr-2"
      >
        <use xlink:href="#down" />
      </svg>
    </template>
  </Multiselect>
</template>

<style lang="scss">
@import "@vueform/multiselect/themes/default.css";
@import "../../styles/utils/variables.scss";
.multiselect {
	max-width: 220px;
	min-width: 220px;
	--ms-placeholder-color: #000;
  border-radius: $border-radius !important;
  border: 1px solid rgba(186, 202, 230, 1) !important;
  box-shadow: none !important;
  font-size: 14px;

	.down_icon {
		stroke: #000;
		width: 20px;
		background-color: inherit;
		transition: transform 0.3s;
		pointer-events: none;
	}
	&.is-active {
		.down_icon {
			transform: rotate(-180deg);
		}
	}
	&-dropdown {
		bottom: -5px;
		max-height: 200px;
		padding-top: 12px;
		padding-bottom: 12px;
		border-radius: $border-radius;
		box-shadow: 0px 2px 10px 0px #f3f4f6;

		&::-webkit-scrollbar {
			width: 5px;
			border-radius: $border-radius;
		}

		/* Handle */
		&::-webkit-scrollbar-thumb {
		background: #e6e6e6;
		border-radius: $border-radius;
		}
		z-index: 11;
	}
	&-option {
		padding: 4px 12px;
	}

	&-clear {
		padding: 0;
		margin-right: 14px;
	}

	@media (max-width: $screen-md) {
		max-width: none;
	}
}
</style>
